import React from 'react';
import Navbar from "../main_website/Navbar";
import AboutBanner from './AboutBanner';
import PlanStat from './PlanStat';
import AboutVideo from './AboutVideo';
import AboutStatt from './AboutStatt';
import Whatsapp from './Whatsapp';
import Footer from "../main_website/Footer";





const About = () => {


  return (
    <div className="women-container">      
      <Navbar />
     
      <AboutBanner/><br /><br /><br />
      
      <PlanStat/>
      <AboutVideo/>
     <br /><br />
     
    
   
     
     <AboutStatt/>
     <br /><br />
     <Whatsapp />
     <Footer />
    </div>
    
  );
};

export default About;
